import { TosType, TosUpdatedDates } from './types';

export enum ActionTypes {
  APPLICATION_TOS_UPDATE_DATE_LOAD_START = 'APPLICATION_TOS_UPDATE_DATE_LOAD_START',
  APPLICATION_TOS_UPDATE_DATE_LOAD_SUCCEED = 'APPLICATION_TOS_UPDATE_DATE_LOAD_SUCCEED',
  APPLICATION_TOS_UPDATE_DATE_LOAD_FAILED = 'APPLICATION_TOS_UPDATE_DATE_LOAD_FAILED',

  APPLICATION_TOS_ACCEPT_START = 'APPLICATION_TOS_ACCEPT_START',
  APPLICATION_TOS_ACCEPT_SUCCEED = 'APPLICATION_TOS_ACCEPT_SUCCEED',
  APPLICATION_TOS_ACCEPT_FAILED = 'APPLICATION_TOS_ACCEPT_FAILED',

  APPLICATION_TOS_NEXT_UPDATE_LOAD_START = 'APPLICATION_TOS_NEXT_UPDATE_LOAD_START',
  APPLICATION_TOS_NEXT_UPDATE_LOAD_SUCCEED = 'APPLICATION_TOS_NEXT_UPDATE_LOAD_SUCCEED',
  APPLICATION_TOS_NEXT_UPDATE_LOAD_FAILED = 'APPLICATION_TOS_NEXT_UPDATE_LOAD_FAILED',
}

export type ApplicationTosUpdateDateLoadStartAction = {
  type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_START;
};

export type ApplicationTosUpdateDateLoadSucceedAction = {
  type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_SUCCEED;
  dates: TosUpdatedDates;
};

export type ApplicationTosUpdateDateLoadFailedAction = {
  type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_FAILED;
  error: string;
};

export type ApplicationTosAcceptStartAction = {
  type: ActionTypes.APPLICATION_TOS_ACCEPT_START;
};

export type ApplicationTosAcceptSucceedAction = {
  type: ActionTypes.APPLICATION_TOS_ACCEPT_SUCCEED;
  timestamp: string;
  tosType: TosType;
};

export type ApplicationTosAcceptFailedAction = {
  type: ActionTypes.APPLICATION_TOS_ACCEPT_FAILED;
  error: string;
};

export type ApplicationTosNextUpdateLoadStartAction = {
  type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_START;
};

export type ApplicationTosNextUpdateLoadSucceedAction = {
  type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_SUCCEED;
  dates: TosUpdatedDates;
};

export type ApplicationTosNextUpdateLoadFailedAction = {
  type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_FAILED;
  error: string;
};

export type ApplicationAction =
  | ApplicationTosUpdateDateLoadStartAction
  | ApplicationTosUpdateDateLoadSucceedAction
  | ApplicationTosUpdateDateLoadFailedAction
  | ApplicationTosAcceptStartAction
  | ApplicationTosAcceptSucceedAction
  | ApplicationTosAcceptFailedAction
  | ApplicationTosNextUpdateLoadStartAction
  | ApplicationTosNextUpdateLoadSucceedAction
  | ApplicationTosNextUpdateLoadFailedAction;
